module.exports = __webpack_public_path__ + "static/musicalanimalhamper-a7b5f32cabd8cd1c6fcb1461f41d63b1.jpeg";